/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getInfo as o } from "../../../geometry/support/spatialReferenceUtils.js";

function r(o, r) {
  if (!r.supported) return;
  var p = 1 / 0,
      e = -1 / 0;
  var u = r.upperBoundX - r.lowerBoundX;
  o.forEach(function (o) {
    var n = o.pos[0];

    for (; n < r.lowerBoundX;) {
      n += u;
    }

    for (; n > r.upperBoundX;) {
      n -= u;
    }

    p = Math.min(p, n), e = Math.max(e, n), o.pos[0] = n;
  });
  var n = e - p;
  u - n < n && o.forEach(function (o) {
    o.pos[0] < 0 && (o.pos[0] += u);
  });
}

function p(r, p) {
  var e = o(r);
  return 1 === p && e ? {
    supported: !0,
    lowerBoundX: e.valid[0],
    upperBoundX: e.valid[1]
  } : {
    supported: !1,
    lowerBoundX: null,
    upperBoundX: null
  };
}

export { p as getUnnormalizationInfo, r as unnormalize };